export const modifyWithNewsletterPlaceholderDiv = (body) => {
	const splitSeparator = "<h2";
	const splitByH2 = body.split(splitSeparator);
	const wrapperMarkup = `<ClientOnly><NewsletterBanner></NewsletterBanner></ClientOnly>`;

	if (splitByH2.length <= 1) {
		return `${body}${wrapperMarkup}`;
	}

	splitByH2[1] = `${splitByH2[1]}${wrapperMarkup}`;
	return splitByH2.join(splitSeparator);
};
